import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { RadioButtonModule } from "primeng/radiobutton";
import { ErrorCheck } from "src/app/shared/models/error-check.model";
import * as ProfileModel from "src/app/shared/models/profile.model";
import { ErrorMessageComponent } from "src/app/modules/esim/shared/components/error-message/error-message.component";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";

/**
 * Characters EF_DOMAIN's home network domain holds. The domain is written as a TLV whose length
 * is a single short-form BER byte, so anything past 127 would encode an invalid length.
 */
export const HOME_NETWORK_DOMAIN_NAME_MAX_LENGTH = 127;

@Component({
  selector: C.EWIZ_HOME_NETWORK_DOMAIN_NAME,
  templateUrl: "./home-network-domain-name.component.html",
  standalone: true,
  imports: [FormsModule, InputTextModule, RadioButtonModule, ErrorMessageComponent]
})
export class EWizHomeNetworkDomainNameComponent extends EWizDynamicBaseClassComponent implements OnInit, ErrorCheck {
  protected readonly maxLength = HOME_NETWORK_DOMAIN_NAME_MAX_LENGTH;

  ngOnInit() {
    if (this.profileValues) {
      this.errorCheck(this.profileValues);
    }
  }

  errorCheck(values: ProfileModel.ProfileDto) {
    this.errorFound = (values.isimConfiguration?.homeNetworkDomainName?.length ?? 0) > HOME_NETWORK_DOMAIN_NAME_MAX_LENGTH;
    this.errorMessage = this.errorFound ? $localize`Home Network Domain Name values must not exceed 127 characters` : "";

    return this.errorFound;
  }
}
